

/**
 * Timer class
 */
export class Timer {

    private timeout: number = 0;
    private callback: Function;
    private timer: any = null;

    /**
     * 
     * @param {object} param0
     *      @param {nubmer} param0.timeout
     *      @param {function} param0.callback
     */
    constructor({timeout, callback}: {timeout: number, callback: Function}) {
        this.timeout = timeout;
        this.callback = callback;
        this.init();
    }
    init = () => {
        this.timer = setTimeout(() => {
            this.callback();
        }, this.timeout);
    }
    /**
     * clears the timer
     */
    clear = () => {
        clearTimeout(this.timer); 
    }
}



// const timer = new Timer({
//     timeout: 2000,
//     callback: () => {
//         console.warn("timer timeout callback");
//     }
// });

// console.log("timer running..."); 
// setTimeout(() => {
//     timer.clear();
//     console.log("cleared the timer");  
// }, 1000);

